import { Route } from 'react-router-dom'
import RegularPlanAlertSheetPage from '../RegularPlanAlertSheet/RegularPlanAlertSheetPage'

export const bottomSheetPageRoutes = () => [
  <Route
    key="regular-plan-alert-sheet"
    path="/regular-plan-alert-sheet"
    element={<RegularPlanAlertSheetPage />}
  />,
]
